export default __webpack_public_path__ + "static/media/about_ron_desc.a0226cf4.png";